import { render } from "./CodeAttribute.vue?vue&type=template&id=6d1c9f48"
import script from "./CodeAttribute.vue?vue&type=script&lang=js"
export * from "./CodeAttribute.vue?vue&type=script&lang=js"

import exportComponent from "/Users/carterharrison/Documents/github/cf/api-platform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__